import React from 'react';
import { AiOutlineClose } from 'react-icons/ai'; // Import a close icon from react-icons

const Modal = ({ isOpen, toggleModal }) => {
  if (!isOpen) return null;

  // Function to handle clicking outside of the modal box
  const handleOutsideClick = (e) => {
    if (e.target.id === 'modal-wrapper') {
      toggleModal();
    }
  };

  return (
    <div 
      id="modal-wrapper" 
      className="fixed top-0 left-0 w-full h-full bg-black bg-opacity-50 flex items-center justify-center" 
      onClick={handleOutsideClick}
    >
      <div className="relative bg-white p-6 rounded-lg w-80 h-80">
        {/* Close button in top right corner */}
        <button className="absolute top-2 right-2 text-gray-600 hover:text-gray-900" onClick={toggleModal}>
          <AiOutlineClose size={24} />
        </button>

        {/* Modal content */}
        <h2 className="font-bold text-xl mb-4">About Cine Field</h2>
        <p>Here you can add more detailed information about the Cine Field, its history, or any relevant information.</p>

  
      </div>
    </div>
  );
};

export default Modal;
